import { QuickPaySuccessReceiptGuard } from '@components/modules/customerPayment/QuickPaySuccessReceiptGuard';
import { PayLayout } from '@components/templates';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import {
  customerPaymentPath,
  customerPaymentPendingActionPath,
  customerPaymentProcessingPath,
  customerPaymentSuccessPath,
  quickPayCustomerPaymentPath,
  quickPayCustomerPaymentPendingActionPath,
  quickPayCustomerPaymentProcessingPath,
  quickPayCustomerPaymentSuccessPath,
  quickPayCustomerPaymentWalletReturnPath,
} from './urls';

const CustomerPayment = lazyWithReload(() =>
  import('./pages/CustomerPayment').then((m) => ({ default: m.CustomerPayment }))
);

const PaymentSuccess = lazyWithReload(() =>
  import('./pages/PaymentSuccess').then((m) => ({
    default: m.PaymentSuccess,
  }))
);

const PaymentProcessing = lazyWithReload(() =>
  import('./pages/PaymentProcessing').then((m) => ({
    default: m.Container,
  }))
);

const PendingAction = lazyWithReload(() =>
  import('./pages/PendingAction').then((m) => ({
    default: m.Container,
  }))
);

const QuickPayCustomerPayment = lazyWithReload(() =>
  import('./pages/QuickPayCustomerPayment').then((m) => ({
    default: m.QuickPayCustomerPayment,
  }))
);

const QuickPaySuccess = lazyWithReload(() =>
  import('./pages/QuickPaySuccess').then((m) => ({ default: m.QuickPaySuccess }))
);

const QuickPayProcessing = lazyWithReload(() =>
  import('./pages/QuickPayProcessing').then((m) => ({ default: m.QuickPayProcessing }))
);

const QuickPayPendingAction = lazyWithReload(() =>
  import('./pages/QuickPayPendingAction').then((m) => ({ default: m.QuickPayPendingAction }))
);

const QuickPayWalletReturn = lazyWithReload(() =>
  import('./pages/QuickPayWalletReturn').then((m) => ({ default: m.QuickPayWalletReturn }))
);

export const CustomerPaymentRoutes = (
  <Route element={<PayLayout />}>
    <Route path={customerPaymentPath} element={<CustomerPayment />} />
    <Route path={customerPaymentSuccessPath} element={<PaymentSuccess />} />
    <Route path={customerPaymentProcessingPath} element={<PaymentProcessing />} />
    <Route path={customerPaymentPendingActionPath} element={<PendingAction />} />
    <Route path="/pay/test" element={<CustomerPayment />} />
    <Route path={quickPayCustomerPaymentWalletReturnPath} element={<QuickPayWalletReturn />} />
    <Route path={quickPayCustomerPaymentProcessingPath} element={<QuickPayProcessing />} />
    <Route path={quickPayCustomerPaymentPendingActionPath} element={<QuickPayPendingAction />} />
    <Route
      path={quickPayCustomerPaymentSuccessPath}
      element={
        <QuickPaySuccessReceiptGuard paramName="paymentId">
          <QuickPaySuccess />
        </QuickPaySuccessReceiptGuard>
      }
    />
    <Route path={quickPayCustomerPaymentPath} element={<QuickPayCustomerPayment />} />
  </Route>
);

export default CustomerPaymentRoutes;
